export default class Cursor {

  constructor () {

    this.mousePos = '';
    this.isHovering = false;
    this.cursorClass = '';
    this.hoveredElement = '';
    this.cursorIsLocked = false;
  }

  desktopInit() {

    if($('#pointer').length) {
      return;
    }

    this.$pointer = this.makePointer();
    this.setScrollCursorPositions();
    this.bindEvents();
    this.hideDefaultCursor();
  }

  mobileInit() {
    //this.addIconsForMobile();
  }

  bindEvents() {

    $(document).mousemove( (event) => {
      this.trackCursor(event);

      this.checkHover();
    });

    $('body').on('mousewheel DOMMouseScroll', (event) => {

      if( $('.header--open').length ) {
        return;
      }

      this.isHovering = false;
      this.hoveredElement = '';
      $('[data-cursor]:visible').each((index, cursor) => {
        let $cursor = $(cursor);
        let offset = $cursor.offset();
        let offsetBottom = $cursor.height() + offset.top;

        if(event.pageY > offset.top && event.pageY < offsetBottom) {
          this.isHovering = true;
          this.hoveredElement = $cursor;
          let newCursorClass = $cursor.data('cursor');

          if(this.cursorClass !== newCursorClass) {
            this.cursorClass = newCursorClass;
            $(document).trigger('cursor-changed');
          }
        }
      });
      if(!this.isHovering) {
        this.$pointer.removeClass();
        this.cursorClass = false;
      }
    });

    $(document).on('cursor-changed', () => {
      if(this.cursorIsLocked) {
        return;
      }
      this.$pointer.removeClass();
      this.$pointer.addClass(this.cursorClass);
    })
  }

  trackCursor(event) {
    this.$pointer.css({
      'top': event.clientY,
      'left': event.clientX,
    });
  }

  checkHover() {
    if ($('[data-flip-cursor]:hover').length > 0) {
      this.changeCursor('pointer--white pointer--hover');
      return;
    }

    if ($('a:hover, [data-cursor]:hover').length > 0) {
      let cursorClass = $('[data-cursor]:hover').data('cursor') || 'pointer--hover';
      this.hoveredElement = $('[data-cursor]:hover');
      this.changeCursor(cursorClass);
      return;
    }


    this.$pointer.removeClass();
    this.cursorClass = false;
    this.hoveredElement = '';
  }

  makePointer() {
    let $pointer = $("<div id='pointer'></div>");
    $pointer.appendTo( 'body' );

    return $pointer;
  }

  setScrollCursorPositions() {
    let positions = [];
    $('[data-cursor]').each((index, cursor) => {
      let $cursor = $(cursor);
      let offset = $cursor.offset();
      let offsetBottom = $cursor.height() + offset.top;
      positions.push([offset.top, offsetBottom]);
    });

    this.getScrollCursorPositions = positions;
  }

  changeCursor(cursorClass) {
    if(this.cursorClass !== cursorClass) {
      this.cursorClass = cursorClass;
      $(document).trigger('cursor-changed');
    }
  }

  lockCursor(cursorClass) {
    if(!this.$pointer) {
      return;
    }
    this.$pointer.removeClass();
    this.$pointer.addClass(cursorClass);
    this.cursorIsLocked = true;
  }

  resetCursor() {
    if(!this.$pointer) {
      return;
    }
    this.cursorIsLocked = false;
    this.cursorClass = '';
    this.$pointer.removeClass();
  }

  addIconsForMobile() {
    $('.video[data-cursor], .image-video-columns__video[data-cursor]').each((index, element) => {
      let $pointer = $("<div data-mobile-pointer></div>");
      let cursorClass = $(element).data('cursor');
      $pointer.addClass(cursorClass);
      $pointer.appendTo( $(element) );

      this.updateIconsForMobile($pointer, cursorClass);
      $('body').addClass('has-cursor');
    });
  }

  updateIconsForMobile(cursor, cursorClass) {
    $(cursor).removeClass();
    $(cursor).addClass( cursorClass );
  }

  hideDefaultCursor() {
    $('body').append('<style type="text/css">body * { cursor: none !important }</style>');
  }

}




// WEBPACK FOOTER //
// ./scripts/modules/cursor.js